module.exports = __webpack_public_path__ + "img/regular.3d489660.png";